import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#0098cc",
        secondary: "#4068b2",
        ultramarin: "#003871",
        kaka: "#b71c1c",
        accent: "#8c9eff",
        error: "#990000"
      },
      dark: {
        primary: "#003871",
        secondary: "#00001f",
        accent: "#8c9eff",
        error: "#b71c1c"
      }
    }
  }
});
